module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/isNaN.js
// module id = ./node_modules/es-abstract/helpers/isNaN.js
// module chunks = 0 1